import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "modal-content neon" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = {
  key: 1,
  class: "pdf-viewer"
}
const _hoisted_4 = ["src", "title"]
const _hoisted_5 = ["src", "title"]
const _hoisted_6 = ["src", "title"]
const _hoisted_7 = { class: "pdf-controls" }
const _hoisted_8 = { class: "btn-close" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_modal_header = _resolveComponent("app-modal-header")!
  const _component_AppLoader = _resolveComponent("AppLoader")!
  const _component_app_button = _resolveComponent("app-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_app_modal_header, {
      title: _ctx.fileName,
      onClose: _ctx.close
    }, null, 8, ["title", "onClose"]),
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
        : _createCommentVNode("", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            (_ctx.device === 'android' && _ctx.pdfBlobUrl)
              ? (_openBlock(), _createElementBlock("iframe", {
                  key: 0,
                  src: _ctx.pdfBlobUrl,
                  class: "pdf-iframe",
                  title: `Просмотр ${_ctx.fileName}`
                }, null, 8, _hoisted_4))
              : (_ctx.device === 'ios')
                ? (_openBlock(), _createElementBlock("embed", {
                    key: 1,
                    src: _ctx.pdfDirectUrl,
                    type: "application/pdf",
                    class: "pdf-embed",
                    title: `Просмотр ${_ctx.fileName}`
                  }, null, 8, _hoisted_5))
                : (_openBlock(), _createElementBlock("iframe", {
                    key: 2,
                    src: _ctx.pdfDirectUrl,
                    class: "pdf-iframe",
                    title: `Просмотр ${_ctx.fileName}`
                  }, null, 8, _hoisted_6))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_app_button, {
            severity: "warning",
            title: "close",
            onClick: _ctx.close
          }, null, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}